import { Button, Alert } from "react-bootstrap";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Popup from "../../common/modal/Popup";

const AlertMessage = ({ onHide, alertModalShow }) => {
  const [warning, setWarning] = useState(false);

  const dispatch = useDispatch();

  return (
    <>
      <Popup
        onHide={() => onHide()}
        size="md"
        show={alertModalShow}
        title={"Alert Message"}
        footer={
          <>
            <Button
              variant="outline-secondary model-btn"
              className="me-4"
              onClick={(e) => onHide()}
            >
              Ok
            </Button>
          </>
        }
      >
        <div style={{ textAlign: "center" }}>
          "If you select ward Type 'None' then no ward Type  will be
          selected."
        </div>
      </Popup>
    </>
  );
};

export default AlertMessage;
